import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/tenantAdmins/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/tenantAdmins/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/tenantAdmins/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/tenantAdmins/delete',
    method: 'post',
    data
  })
}

